// extracted by mini-css-extract-plugin
module.exports = {"popover-content":"info-popover__popover-content___1_b47"};